import { errorsFactory } from '../../utils';

const CheckCodeError = errorsFactory('CheckCodeError');

export default CheckCodeError;
